import clsx from 'clsx';

interface FooterProps {
  children: React.ReactNode;
  className?: string;
}

const Footer = ({ children, className }: FooterProps) => {
  return (
    <div
      className={clsx(
        'flex w-full border-t border-base-300 bg-base-150 p-8 shadow-[0px_0px_5px_0px_rgba(91,94,93,0.20)_inset]',
        className
      )}
    >
      {children}
    </div>
  );
};

export default Footer;
